<template>
  <div class="gp-has-header">
    <mdb-container>
      <mdb-card>
        <mdb-card-header>
          <h4>{{ item.type }} Section Editor</h4>
        </mdb-card-header>
        <mdb-card-body v-if="item.type=='Content'" class="text-left">
          <mdb-input v-model="item.content.title" label="Title" placeholder="Title" type="text"/>
          <mdb-input :id="'checkbox-'+item.id" v-model="item.hideTitle" type="checkbox"
                     label="Don't Show Title on Homepage"/>
          <editor :field="item.content.html" :group="group"
                  label="Document Body" @input="item.content.html = $event" @wizardDone="save"/>
        </mdb-card-body>
        <mdb-card-body v-if="item.type=='Facebook Feed'" class="text-left">
          <div class="text-info small">Do not use a full URL here. Just the page name.  For example, if the
            Facebook page is at https://facebook.com/nytimes, simply enter nytimes in this box.
          </div>
          <mdb-input v-model="item.facebookPage" label="Page Name" placeholder="Facebook Page" type="text"/>
          <mdb-input v-model="item.pageLinksTitle" label="Title" placeholder="Title" type="text"/>
        </mdb-card-body>

        <mdb-card-body v-if="item.type=='Twitter Feed'" class="text-left">
          <div class="text-info small">Do not use the @ sign. Just the name. For example, use elonmusk instead of @elonmusk.</div>
          <mdb-input v-model="item.twitterName" label="Twitter Name" placeholder="Name" type="text"/>
          <mdb-input v-model="item.tweetsToShow" label="# Tweets to Show" placeholder="Max #" type="number" :step="1"/>
        </mdb-card-body>

        <mdb-card-body v-if="item.type == 'Team'">
          Who should show up in the Team Spotlight?
          <select id="sys-freq" v-model="item.teamDisplay" class="browser-default custom-select">
            <option value="0">Admins Only</option>
            <option value="1">Admins & Group Organizers</option>
            <option value="2">Admins, Group Organizers & Event Organizers</option>
          </select>
        </mdb-card-body>
        <mdb-card-body v-if="item.type=='Image'">
          <mdb-btn @click="showImageSelector = true">
            <mdb-icon icon="images"/>
            Select from Library
          </mdb-btn>
          <img :src="item.image" width="100%"/>
        </mdb-card-body>
        <mdb-card-body v-if="item.type=='File Folder'" class="text-left">
          <mdb-input v-model="item.pageLinksTitle" label="Section Title"/>
          <gp-select :dataObj="item" :possible-values="availableFolders"
                     :required="true"
                     label="Folder" propertyName="folderId"/>
        </mdb-card-body>

        <mdb-card-body v-if="item.type=='RSS Feed'" class="text-left">
          <div v-if="rssAddDialog">
            <mdb-row>
              <mdb-col col="8">
                <mdb-input v-model="rssFeedUrl" placeholder="RSS/Atom URL" label="Add a New Feed" icon="browser"/>
              </mdb-col>
              <mdb-col col="2">
                <mdb-btn :disabled="!rssFeedUrl" @click="addFeed" size="sm" icon="plus-circle" color="success" rounded>Add</mdb-btn>
              </mdb-col>
              <mdb-col col="2">
                <mdb-btn @click="rssAddDialog = false" size="sm" icon="minus-circle" color="warning" rounded>Cancel</mdb-btn>
              </mdb-col>
            </mdb-row>
          </div>
          <div v-if="!rssAddDialog">
            <h3>Select a Feed</h3>
            <mdb-row>
              <mdb-col col="8">
                <mdb-input v-model="rssQuery" placeholder="Name to Find" label="Search" icon="search"/>
              </mdb-col>
              <mdb-col col="2">
                <mdb-btn :disabled="!rssQuery" @click="loadRss" size="sm" icon="search" rounded>Go</mdb-btn>
              </mdb-col>
              <mdb-col col="2">
                <mdb-btn @click="resetRss" size="sm" icon="minus-circle" rounded>Reset</mdb-btn>
              </mdb-col>
            </mdb-row>
            <div v-if="rssTotal > rssLimit" class="text-center">
              <mdb-btn @click="prevRss" :disabled="rssOffset == 0" icon="arrow-left" size="sm" rounded/>
              <mdb-btn @click="nextRss" :disabled="rssOffset > (rssTotal - rssLimit)" icon="arrow-right"
                       size="sm" rounded/>
            </div>
            <mdb-row v-if="rssFeeds.length>0">
              <div v-for="(f,i) in rssFeeds" :key="i" class="col-lg-3 col-md-12 d-flex align-self-stretch">
                <mdb-card class="mb-4" style="width:100%">
                  <mdb-card-body class="text-center">
                    <img v-if="f.imageUrl" :src="f.imageUrl" style="max-width:100%"/>
                    <h5 class="text-primary">{{ f.title }}</h5>
                  </mdb-card-body>
                  <mdb-card-footer class="text-center">
                    <mdb-btn @click="saveFeed(f)" size="sm" rounded icon="check">Select</mdb-btn>
                  </mdb-card-footer>
                </mdb-card>
              </div>
            </mdb-row>
            <div class="text-center">
              <mdb-btn @click="rssAddDialog=true" icon="plus-circle" color="success">Add a New Feed</mdb-btn>
              </div>
          </div>
        </mdb-card-body>

        <mdb-card-body v-if="item.type=='Page Links'" class="text-left">
          <mdb-input v-model="item.pageLinksTitle" label="Section Title"/>

          <mdb-tbl responsive striped>
            <mdb-tbl-body>
              <tr v-for="(link,i) in item.links" v-bind:key="i">
                <td>
                  <mdb-input v-model="link.title" label="Label"/>
                </td>
                <td>
                  <div v-if="link.type=='CONTENT'">
                    <mdb-badge color="primary">Document</mdb-badge>
                    {{ link.internalTitle }}
                  </div>
                  <div v-if="link.type=='CARD_PAGE'">
                    <mdb-badge color="secondary">Card Page</mdb-badge>
                    {{ link.internalTitle }}
                  </div>
                  <mdb-input v-if="link.type == 'EXTERNAL'" v-model="link.externalURL" label="External URL"/>
                </td>
                <td>
                  <mdb-btn color="danger" floating icon="trash" size="sm" tag="a" @click="deleteLink(link)">Delete
                  </mdb-btn>
                </td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>

          <mdb-btn icon="file-alt" size="sm" @click="documentSelector = true">Add Document</mdb-btn>
          <mdb-btn icon="external-link" size="sm" @click="addExternalLink">Add External URL</mdb-btn>
        </mdb-card-body>

        <mdb-card-footer>
          <mdb-btn v-if="item.type != 'RSS Feed'" :disabled="!allowSave" color="success" icon="save" @click="save">
            Save
          </mdb-btn>
          <mdb-btn color="warning" icon="minus-circle" @click="$emit('cancelEdit')">Cancel</mdb-btn>
        </mdb-card-footer>
      </mdb-card>
      <mdb-modal :show="documentSelector" class="text-center" size="lg" @close="documentSelector=false">
        <mdb-modal-header center class="primary-color-dark text-white">
          <h5>Select a Document</h5>
        </mdb-modal-header>
        <mdb-modal-body class="text-left">
          <div v-for="(doc,i) in availablePages" :key="i">
            <a href="" @click.prevent="addDoc(doc)">{{ doc.title }}</a>
          </div>
        </mdb-modal-body>
      </mdb-modal>
      <mdb-modal :show="showImageSelector" @close="showImageSelector = false">
        <mdb-modal-header :close="true" center class="secondary-color">Select an Image
        </mdb-modal-header>
        <mdb-modal-body>
          <image-selector :group="group" emitOnSelection="imageSelected" @imageSelected="imageSelected"/>
        </mdb-modal-body>
      </mdb-modal>

    </mdb-container>

  </div>
</template>

<script>
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbCardImage,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbListGroup,
  mdbListGroupItem,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbRow,
  mdbSelect,
  mdbSwitch,
  mdbTbl,
  mdbTblBody,
  mdbView
} from 'mdbvue';
import api from '../../services/groupsPlaceApi.js'
import imageSelector from '../group/ImageSelector'
import Editor from "../group/Editor";
import gpSelect from "../common/GPSelect";

export default {
  name: 'SectionDesigner',
  components: {
    mdbSwitch,
    mdbBadge,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbCardImage,
    mdbView,
    mdbMask,
    mdbIcon,
    mdbRow,
    mdbCol,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbContainer,
    mdbSelect,
    mdbInput,
    mdbListGroup,
    mdbListGroupItem,
    mdbTbl,
    mdbTblBody,
    imageSelector,
    Editor,
    gpSelect
  },
  data() {
    return {
      bodyVisible: false,
      confirm: false,
      editMode: false,
      teamDisplay: null,
      showImageSelector: false,
      availableContent: [],
      newContentId: null,
      newContentTitle: "",
      selectedImage: null,
      documentSelector: false,
      editingContent: false,
      workingHtml: null,
      workingTitle: null,
      rssLimit: 8,
      rssFeeds: [],
      rssFeedUrl: "",
      rssTotal: 0,
      rssOffset: 0,
      rssQuery: null,
      rssAddDialog: false

    }
  },
  computed: {
    group() {
      return this.$store.state.currentGroup
    },
    allowSave() {
      if (this.item.type == 'Facebook Feed' && !this.item.facebookPage) return false
      if (this.item.type == 'Twitter Feed' && (!this.item.twitterName | !this.item.tweetsToShow)) return false
      if (this.item.type == 'Content') {
        if (!this.item.content.title || !this.item.content.html) return false
      }
      if (this.item.type == 'Image' && this.selectedImage) return true
      if (this.item.type == 'Team' && this.teamDisplay) return true
      if (this.item.type == 'File Folder') {
        if (!this.item.pageLinksTitle) return false
        if (!this.item.folderId) return false
      }

      if (this.item.type == "Page Links") {
        if (!this.item.pageLinksTitle) return false
        if (!this.item.links || this.item.links.length == 0) return false
        for (let i = 0; i < this.item.links.length; i++) {
          let link = this.item.links[i]
          if (link.type == "EXTERNAL" && !link.externalURL) return false
          if (link.type == "CARD_PAGE" && !link.cardPageId) return false
          if (link.type == "CONTENT" && !link.contentId) return false
          if (!link.title) return false
        }
      }

      return true

    },
    editable() {
      if (this.item.type == 'Content' || this.item.type == 'Page Links' ||
        this.item.type == "Image" || this.item.type == "Team") {
        return true
      }
      return false
    }
  },
  mounted() {
    this.teamDisplay = this.item.teamDisplay
    if (!this.item.id) {
      this.editMode = true
    }
    for (let i = 0; i < this.pageTypes.length; i++) {
      let row = this.pageTypes[i]
      if (row.value == this.item.type) row.selected = true
    }
    if (this.availablePages.length > 0 &&
      (this.item.type == 'Content' || this.item.type == 'Page Links')) {
      for (let i = 0; i < this.availablePages.length; i++) {
        let doc = this.availablePages[i]
        if (doc.type == "CONTENT") {
          let item = {text: doc.title, value: doc.id, type: doc.type, selected: false}
          if (this.item.type == 'Content' && this.item.content.id == doc.id) {
            item.selected = true
          }
          this.availableContent.push(item)
        }
      }
    }
    if (this.item.type == "RSS Feed") {
      this.loadRss()
    }
    window.scrollTo(0, 0)

  },
  methods: {
    addExternalLink() {
      let d = {
        id: null,
        internalTitle: "",
        title: "",
        type: "EXTERNAL",
        contentId: null,
        cardPageId: null,
        externalURL: ""
      }
      if (!this.item.links) this.item.links = []
      this.item.links.push(d)
    },
    deleteLink(link) {
      let loc = this.item.links.indexOf(link)
      this.item.links.splice(loc, 1)
    },
    typeChanged: function (value, text) {
      this.item.type = value;
    },
    contentChanged: function (value, text) {
      //this.item.content.id = value;
      for (let i = 0; i < this.availableContent.length; i++) {
        let content = this.availableContent[i]
        if (content.value == value) {
          this.newContentId = content.value
          this.newContentTitle = text
        }
      }
    },
    closeEdit: function () {

    },
    imageSelected: function (image) {
      this.showImageSelector = false
      this.selectedImage = image
      this.item.image = image.thumb
      this.item.imageId = image.id
      this.allowSave = true
    },
    addFeed() {
      this.item.existingFeed = false
      this.item.feedUrl = this.rssFeedUrl
      this.save()
    },
    saveFeed(feed) {
      this.item.feedId = feed.id
      this.item.existingFeed = true
      this.save()
    },
    save() {
      this.$store.dispatch("setExecuting", true)
      if (this.item.type == "Content" && !this.item.content.title) this.item.content.title = "New Document"
      api.post("/homepage/save/" + this.group.vanityPath, this.item).then(
        (results) => {
          this.$emit("saved")
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})

        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    cancel: function () {
      if (!this.item.id) {
        this.item.editMode = false
        this.$emit("deleteSection", this.item.id)
      }
      this.editMode = false

    },
    prevRss: function () {
      this.rssOffset -= this.rssLimit
      this.loadRss()
    },
    nextRss: function () {
      this.rssOffset += this.rssLimit
      this.loadRss()
    },
    resetRss: function () {
      this.rssQuery = "";
      this.loadRss();
    },
    loadRss: function () {
      this.$store.dispatch("setExecuting", true)
      api.post("/rssFeed/list", {offset: this.rssOffset, max: this.rssLimit, query: this.rssQuery}).then(
        (results) => {
          this.rssFeeds = results.data.rows
          this.rssTotal = results.data.totalCount
        },
        (error) => {
          this.$notify.error({
                               message: "Could not load RSS Feeds.",
                               timeOut: 5000,
                               position: 'top center'
                             })
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    handlePublic: function (val) {
      this.item.isPublic = val
      this.$store.dispatch("setExecuting", true)
      api.post("/homepage/setPerm/" + this.item.id, {field: "isPublic", value: val}).then(
        (results) => {
          //life is good
        },
        (error) => {
          this.$notify.error({
                               message: "Setting could not be saved. Please try again later.",
                               timeOut: 5000,
                               position: 'top center'
                             })
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    deleteConfirm: function () {
      this.confirm = true
    },
    doDelete: function () {
      this.confirm = false

      api.delete("/homepage/page/" + this.item.id).then(
        (results) => {
          this.$emit("deleteSection", this.item.id)
        },
        (error) => {
          this.$notify.error({
                               message: "Section could not be deleted at this time.",
                               timeOut: 5000,
                               position: 'top center'
                             })
        })

    },
    handleForMembers: function (val) {
      this.item.isForMembers = val
      this.$store.dispatch("setExecuting", true)
      api.post("/homepage/setPerm/" + this.item.id, {field: "isForMembers", value: val}).then(
        (results) => {
          //life is good!
        },
        (error) => {
          this.$notify.error({
                               message: "Setting could not be saved. Please try again later.",
                               timeOut: 5000,
                               position: 'top center'
                             })
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    addDoc(doc) {
      if (!this.item.links) this.item.links = []
      let d = {
        id: null,
        internalTitle: doc.title,
        title: doc.title,
        type: doc.type,
        contentId: null,
        cardPageId: null,
        externalURL: ""
      }
      if (doc.type == "CONTENT") d.contentId = doc.id
      if (doc.type == "CARD_PAGE") d.cardPageId = doc.id
      this.item.links.push(d)
      this.documentSelector = false
    },
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    availablePages: {
      type: Array,
      default: function () {
        return []
      }
    },
    availableFolders: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageTypes: {
      type: Array,
      default: null
    }
  }
};
</script>
<style scoped>
.icons {
  position: absolute;
  right: 0;
  top: 0;
  padding: 8px;
  font-size: 1.3em;
}

</style>

